/**
 * Horizontal Scroller Component
 *
 * Tracks overflow for every horizontal scroller and wires arrow controls when
 * the instance renders them. Sidebar instances use this for mobile overflow
 * fades; non-sidebar instances also use it to manage arrow disabled states.
 *
 * @since 2.2.0
 */

function updateAllOverflowStates () {
  document.querySelectorAll('[data-horizontal-scroller]').forEach(container => {
    const viewport = container.querySelector('.horizontal-scroller__viewport')
    if (!viewport) return

    const maxScroll = viewport.scrollWidth - viewport.clientWidth
    container.classList.toggle('horizontal-scroller--overflowing', maxScroll > 1)
    container.classList.toggle('horizontal-scroller--at-start', viewport.scrollLeft <= 1)
    container.classList.toggle('horizontal-scroller--at-end', viewport.scrollLeft >= maxScroll - 1)

    const prevBtn = container.querySelector('[data-horizontal-scroller-prev]')
    const nextBtn = container.querySelector('[data-horizontal-scroller-next]')
    if (prevBtn) prevBtn.disabled = viewport.scrollLeft <= 0
    if (nextBtn) nextBtn.disabled = viewport.scrollLeft >= maxScroll - 1
  })
}

window.addEventListener('resize', updateAllOverflowStates)

export function initHorizontalScroller () {
  document.querySelectorAll('[data-horizontal-scroller]').forEach(container => {
    initInstance(container)
  })
}

/**
 * @param {HTMLElement} container - The [data-horizontal-scroller] root element.
 */
function initInstance (container) {
  if (container.dataset.horizontalScrollerInitialized === 'true') return

  const viewport = container.querySelector('.horizontal-scroller__viewport')
  const prevBtn = container.querySelector('[data-horizontal-scroller-prev]')
  const nextBtn = container.querySelector('[data-horizontal-scroller-next]')

  if (!viewport) return

  container.dataset.horizontalScrollerInitialized = 'true'

  const updateOverflowState = () => {
    const maxScroll = viewport.scrollWidth - viewport.clientWidth
    container.classList.toggle('horizontal-scroller--overflowing', maxScroll > 1)
    container.classList.toggle('horizontal-scroller--at-start', viewport.scrollLeft <= 1)
    container.classList.toggle('horizontal-scroller--at-end', viewport.scrollLeft >= maxScroll - 1)
  }

  viewport.addEventListener('scroll', updateOverflowState, { passive: true })
  updateOverflowState()

  if (!prevBtn || !nextBtn) return

  const scrollAmount = () => viewport.clientWidth * 0.8

  prevBtn.addEventListener('click', () => {
    viewport.scrollBy({ left: -scrollAmount(), behavior: 'smooth' })
  })

  nextBtn.addEventListener('click', () => {
    viewport.scrollBy({ left: scrollAmount(), behavior: 'smooth' })
  })

  const updateButtonState = () => {
    const maxScroll = viewport.scrollWidth - viewport.clientWidth
    prevBtn.disabled = viewport.scrollLeft <= 0
    nextBtn.disabled = viewport.scrollLeft >= maxScroll - 1
  }

  viewport.addEventListener('scroll', updateButtonState, { passive: true })
  updateButtonState()
}
